import { RsValue } from '../../../models/base/BaseModel';
import { IPerson, PersonFormValues } from '../../../models/person/PersonModel';
import api from '../../axios';

export const personService = {
  listAllPersons: (params?: any): Promise<{ rows: IPerson[]; lastRow: number; count: number }> =>
    api.get('/odata/Person', params),
  getPersonsByHospitalId: (hospitalId: number): Promise<IPerson[]> =>
    api.get(`/Person/${hospitalId}/persons`),
  createPerson: (data: PersonFormValues): Promise<RsValue<IPerson>> =>
    api.post('/Person', {
      name: data.name,
      hospitalId: data.hospitalId,
      phoneNumber: data.phoneNumber,
      email: data.email || undefined,
    }),
  updatePerson: (id: number, data: PersonFormValues): Promise<RsValue<boolean>> =>
    api.put(`/Person/${id}`, {
      id: id,
      name: data.name,
      hospitalId: data.hospitalId,
      phoneNumber: data.phoneNumber,
      email: data.email || undefined,
    }),
  deletePerson: (id: number): Promise<RsValue<boolean>> => api.delete(`/Person/${id}`),
};

